import { useLocation } from 'react-router-dom';

export default function useQueryParams() {
  const searchString = useLocation().search;

  // Support newer browsers
  if ('URLSearchParams' in window) {
    const searchParams = new URLSearchParams(searchString);
    // Search Params is an iterator
    const params = {};
    searchParams.forEach((value, name) => {
      if (params[name]) {
        params[name] = [params[name], value];
      } else {
        params[name] = value;
      }
    });
    return params;
  }

  // Support legacy browsers (Edge 11 <= 16)
  if (searchString && typeof searchString === 'string') {
    const nvps = searchString.split('?')[1].split('&');
    return nvps.reduce((acc, cur) => {
      const [name, value] = cur.split('=');
      return {
        ...acc,
        [name]: value
      };
    }, {});
  }

  return {};
}
